import React, { useState } from "react";

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/16/solid";
import Slider from "react-slick/lib/slider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { homeSlider } from "./newsData";
import { AnimatePresence, motion } from "motion/react";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NewsCarsoul = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const { data, isLoading } = useQuery({
    queryKey: "getAllnewsSlider",
    queryFn: () =>
      axios.get(`${BASEURL}newsroom-slide`).then((res) => {
        return res?.data;
      }),
  });

  const CustomPrevArrow = ({ onClick }) => (
    <ChevronLeftIcon
      onClick={onClick}
      className="w-10 h-10 inline-block absolute left-4 top-52 z-20 rounded-full bg-black bg-opacity-20 text-gray-200 cursor-pointer"
    />
  );

  const CustomNextArrow = ({ onClick }) => (
    <ChevronRightIcon
      onClick={onClick}
      className="w-10 h-10 inline-block absolute right-4  top-52 z-20 text-gray-200 rounded-full bg-black bg-opacity-20 cursor-pointer"
    />
  );
  const settings = {
    dots: true,
    // fade: true,
    lazyLoad: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 6000,
    cssEase: "ease-in-out",
    pauseOnHover: false,
    afterChange: (current) => setActiveIndex(current),
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    customPaging: (i) => (
      <div
        className={`w-2.5 h-2.5 rounded-full cursor-pointer mt-1 ml-1  ${
          i === activeIndex ? "bg-gray-50" : "bg-gray-400"
        }`}
      ></div>
    ),
    appendDots: (dots) => (
      <div
        style={{
          bottom: "15px",

          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ul className="flex justify-center space-x-0.5 bg-black bg-opacity-20 p-1 px-3 rounded-xl">
          <span className=" flex items-center justify-center">{dots}</span>
        </ul>
      </div>
    ),
  };
  return (
    <div>
      <div className="z-10 h-[500px] bg-slate-500 w-full overflow-hidden ">
        {isLoading &&
          Array.from({ length: 6 }).map((_, i) => (
            <Skeleton className="w-full h-[500px] " key={i} />
          ))}
        {!isLoading && (
          <Slider {...settings} className="w-full  cursor-default">
            {data?.data?.map((v, i) => {
              return (
                <div key={i} className="relative">
                  <img
                    src={v.image_url}
                    className="w-full h-[500px] object-center object-cover"
                  />
                  <div
                    className={`z-10 absolute bottom-10 flex justify-center w-full text-green-50 ${
                      activeIndex === i ? "show" : ""
                    }`}
                  >
                    <AnimatePresence>
                      {activeIndex == i && (
                        <motion.h2
                          initial={{ y: 20 }}
                          animate={{ y: 0 }}
                          exit={{ y: -20 }}
                          transition={{ duration: 0.5, ease: "easeInOut" }}
                          className="text-4xl text-black font-semibold px-6"
                        >
                          {v.content}
                        </motion.h2>
                      )}
                    </AnimatePresence>
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default NewsCarsoul;
